import { TranslateFn } from "../../../common/hooks/useStringTranslation";

export interface CartLabels {
    emptyTitle: string;
    emptyDescription: string;
    timerPrefix: string;
    goToCartLabel: string;
    checkoutLabel: string;
    tooltipTitle: string;
    addedToast: string;
    removedToast: string;
    undoLabel: string;
    viewCartLabel: string;
    reserveFailedToast: string;
    refurbishedStatus: string;
}

const getReservationTimerPrefixKey = (itemCount: number): string =>
    itemCount === 1
        ? "cart-reservation-timer-prefix-singular"
        : "cart-reservation-timer-prefix";

export const getCartLabels = (
    t: TranslateFn,
    itemCount: number,
): CartLabels => ({
    emptyTitle: t("cart-empty-title"),
    emptyDescription: t("cart-empty-description"),
    timerPrefix: t(getReservationTimerPrefixKey(itemCount)),
    goToCartLabel: t("cart-go-to-cart"),
    checkoutLabel: t("cart-go-to-checkout"),
    tooltipTitle: t("cart-tooltip"),
    addedToast: t("cart-added-toast"),
    removedToast: t("cart-removed-toast"),
    undoLabel: t("cart-undo"),
    viewCartLabel: t("cart-view-cart"),
    reserveFailedToast: t("cart-reserve-failed"),
    refurbishedStatus: t("refurbished"),
});
